module.exports = __webpack_public_path__ + "static/img/gongzhonghao.4938c7f1.jpg";